
import {Component, Vue, Watch} from "vue-property-decorator";
import SenkronAyarKarti from "@/components/eicrapro/senkron/SenkronAyarKarti.vue";
import SenkronPlanListesi from "@/components/eicrapro/senkron/SenkronPlanListesi.vue";
import SenkronPlanDialog from "@/components/eicrapro/senkron/SenkronPlanDialog.vue";
import SenkronRaporGecmisi from "@/components/eicrapro/senkron/SenkronRaporGecmisi.vue";
import {SenkronPlan, SenkronPlanYazmaCevabi} from "@/services/senkronPlanService";
import {sebepTonu} from "@/services/senkronPlanGovde";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";
import {senkronZamanlayicilariniYenidenKur} from "@/plugins/senkronZamanlayicilar";

/**
 * Senkron planları ekranı (Faz 3, DEV-2966; Ö-P1 kararı: Sorgulama menüsü
 * altında, çoklu plan).
 *
 * Dialog kaydettikten sonra KAPANIR: sunucunun ürettiği `mesaj` BURADA, plan
 * ekranının üstündeki kalıcı şeritte gösterilir — kullanıcı "kaydettim, bu gece
 * koşacak mı" sorusunun cevabını dialog kapandıktan sonra da okuyabilsin diye.
 * (kod inceleme: eski "kapanmaz" iddiası SenkronPlanDialog'un kaydet() davranışıyla
 * çelişiyordu, güncellendi.)
 */
@Component({
  components: {
    UyapBagliDegilView,
    SenkronRaporGecmisi,
    SenkronPlanDialog,
    SenkronPlanListesi,
    SenkronAyarKarti
  }
})
export default class SenkronPlanView extends Vue {
  dialogAcik = false;
  duzenlenenPlan: SenkronPlan | null = null;

  /** Son POST/PATCH cevabının sunucu üretimi Türkçe cümlesi. */
  sunucuMesaji = "";
  sunucuHatasi = "";
  sunucuSebebi = "";

  get mesajTonu(): string {
    return sebepTonu(this.sunucuSebebi);
  }

  mounted() {
    // Bağlantı yokken sayfa UyapBagliDegilView gösteriyor; boşuna istek atılmaz.
    if (this.$store.getters.isUyapConnected) {
      this.$store.dispatch("senkronPlan/planlariYukle");
    }
  }

  /**
   * Bağlantı sonradan kurulursa (kullanıcı e-imzayla bağlanır) ekran kendiliğinden
   * dolsun: aksi halde kullanıcı sayfayı elle yenilemek zorunda kalırdı.
   */
  @Watch("$store.getters.isUyapConnected")
  onBaglanti(bagli: boolean) {
    if (bagli) this.$store.dispatch("senkronPlan/planlariYukle");
  }

  yeniPlan() {
    this.duzenlenenPlan = null;
    this.sunucuMesaji = "";
    this.dialogAcik = true;
  }

  planiDuzenle(plan: SenkronPlan) {
    this.duzenlenenPlan = plan;
    this.sunucuMesaji = "";
    this.dialogAcik = true;
  }

  // kod inceleme: cevap, SenkronPlanDialog/SenkronPlanListesi'nin await edip
  // hatasız döndürdüğü HTTP cevabının ta kendisi (hata varsa emit hiç
  // yapılmaz) ve SenkronPlanYazmaCevabi'de mesaj/sebep/id ZORUNLU alanlar —
  // yani cevap hiçbir zaman null/undefined, id hiçbir zaman falsy olamaz.
  // Gereksiz `cevap?.`/`cevap &&` koruması kaldırıldı; `hata` gerçekten
  // nullable olduğu için oradaki `?? ""` kalıyor.
  kaydedildi(cevap: SenkronPlanYazmaCevabi) {
    // Dialog kapandı; sunucunun cümlesi ekranın üstünde kalıcı olarak gösterilir.
    this.sunucuMesaji = cevap.mesaj;
    this.sunucuSebebi = cevap.sebep;
    // POST üretim hatası alsa bile 201 döner: plan KAYDEDİLDİ ama gece koşumu
    // düşmüş olabilir; iki bilgi ayrı satırlarda verilir.
    this.sunucuHatasi = cevap.hata ?? "";

    // Yeni plan kaydedildiyse dialog artık O PLANI düzenler — tekrar açılıp
    // "Kaydet"e basılırsa ikinci bir plan oluşmasın.
    this.duzenlenenPlan = cevap;

    // Liste store üzerinden zaten güncellendi; rapor da tazelensin (POST tetiği
    // bugün için görev üretmiş olabilir).
    this.$store.dispatch("senkronPlan/raporYukle", {zorla: true});

    // Sunucu bu istekte GÖREV ÜRETTİYSE lokal görev listesi de tazelensin:
    // kullanıcı İşlemler'e geçtiğinde paket zaten listede olur, bir sonraki
    // ayna turunu (dakikada bir) beklemez.
    if (cevap.uretildi || cevap.yeniden_uretildi) {
      this.$store.dispatch("updateTasks");
    }
  }

  /** Saat ayarı değişince zamanlayıcılar yeni saatle yeniden kurulur. */
  zamanlayicilariYenidenKur() {
    senkronZamanlayicilariniYenidenKur(this.$store);
  }
}
